module.exports = __webpack_public_path__ + "img/zone-orange.8178d3e3.png";